import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {fetchSetActiviteTypeActif, fetchTypesActiviteAdmin} from "../../../services/ActivitesService";
import styles from "../Admin.module.css";
import BtnSwitch from "../../../components/Button/BtnSwitch";
import stylesSwitch from "../../../components/Button/BtnSwitch.module.css";
import FilterHamburgerCustom from "../../../components/Filter/FilterHamburgerCustom";
import TitleSecondary from "../../../components/Title/TitleSecondary";
import SearchUtilisateur from "../../../components/Search/SearchUtilisateur";
import SearchCoach from "../../../components/Search/SearchCoach";
import { ReactComponent as AnnulerIcon } from "../../../icons/annuler.svg";
import DateService from "../../../services/DateService";

function AdminAbsencesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const [absences, setAbsences] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getSeance = async (params = null) => {
        let url = params ? `/admin/absences_coach?${params.toString()}` : `/admin/absences_coach`;
        try {
            const response = await AxiosConfig.get(url);
            setAbsences(response.data.myAbsences);
        } catch (error) {
            console.error('error', error);
        }
    }

    useEffect(() => {
        getSeance(queryParams);
    }, [user, mode, location.search]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    const submitUtilisateur = (values) => {
        queryParams.set('filter_utilisateur', values.id);
        navigate(`?${queryParams.toString()}`);
    }

    const submitCoach = (values) => {
        queryParams.set('filter_coach', values.id);
        navigate(`?${queryParams.toString()}`);
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        queryParams.delete(`filter_${key}`);
        navigate(`?${queryParams.toString()}`);
    }

    const putAbsenceActifOpenModal = (absence) => {
        const text = absence.actif ? "Rejeter" : "Valider";
        showModal('confirm', {
            message: `${text} cette absence ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${absence.seance.entrepriseId}/contrats/${absence.seance.contratId}/activites/${absence.seance.activiteId}/seances/${absence.seance.id}/absences/${absence.id}/actif`, { actif: !absence.actif });
                    if (response.data.success) {
                        setTimeout(async () => {
                            getSeance(queryParams);
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const childrenOfFilter = (
        <div style={{display: "flex", flexDirection: "column", gap: "10px", margin: "35px", alignItems: "center"}}>
            <TitleSecondary text="Filtres" />

            <div className={styles.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(queryParams.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        return (
                            <button key={key} className={styles.btnFilterRemove} onClick={removeFilter} >
                                <AnnulerIcon />
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {value}
                            </button>
                        );
                    })
                }
            </div>

            <div className={styles.formBloc}>
                <div>
                    Coach :
                    <SearchCoach onSubmit={submitCoach}/>
                </div>
            </div>
        </div>
    );

    return (
        <div className="content">
            <TitleMain text="Absences de coach"/>

            <FilterHamburgerCustom onReinirFilters={
                () => {
                    const queryParams = new URLSearchParams(location.search);
                    Object.entries({
                        filter_seance_date_start: '',
                        filter_seance_date_end: '',
                        coach: '',
                    }).forEach(([key, value]) => {
                        if (value) {
                            queryParams.append(`filter_${key}`, value);
                        } else {
                            if (queryParams.has(`filter_${key}`)) {
                                queryParams.delete(`filter_${key}`);
                            }
                        }
                    });
                    navigate(`?${queryParams.toString()}`);
                }
            } children={childrenOfFilter}/>

            <div className={styles.viewBloc}>
            {absences && absences.length > 0 ? (
                <ul className={styles.absences}>
                    {absences?.map((absence, index) => {
                        return (
                            <li key={index}>
                                <div>
                                    <span>Créé le </span>
                                    <span>{ DateService.formatDate(absence?.created_at)}</span>
                                </div>

                                <Link to={`/admin/utilisateurs/${absence?.coach.id}`}>{absence?.coach.prenom} {absence?.coach.nom}</Link>

                                <Link to={`/admin/entreprises/${absence.seance.entrepriseId}/contrats/${absence.seance.contratId}/activites/${absence.seance.activiteId}/seances/${absence?.seance?.id}`}>
                                    <span>{absence?.seance?.titre}</span> du <span title={absence?.seance?.heure_debut}>{DateService.formatDate(absence?.seance?.heure_debut)}</span>
                                </Link>

                                <div style={{display: "flex", flexDirection: "row"}}>
                                    <BtnSwitch active={absence?.actif}
                                               onToggle={() => putAbsenceActifOpenModal(absence)}
                                               activeLabel={"Validée"}
                                               inactiveLabel={"Inactive"}
                                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                </div>
                            </li>)
                    })}
                </ul>
            ) : <p>Aucune absence</p>}
            </div>

        </div>
    )
}

export default AdminAbsencesPage;
